<template>
    <el-upload
            class="avatar-uploader"
            :action="url"
            :headers="{'Authorization':token}"
            :limit="1"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-progress="uploadOnProgress">
        <el-progress v-if="circle" type="circle" :percentage="percentage"></el-progress>
        <img v-if="imageUrl" :src="img+imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
</template>

<script>
    import util from '@/libs/util.js'
    //适用于全部img控件
    export default {
        data() {
            return {
                percentage: 0,
                circle: false,
                token: util.cookies.get('token')
            }
        },
        props: {
            img: {}, //图片url前半部分
            imageUrl: {}, //图片参数
            url: {}, //请求路径
        },
        // ['imageUrl',  'url', 'action'],
        methods: {
            handleAvatarSuccess(row) {
                if (row.code === 0) {
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    // this.imgurl = row.data.img
                    this.$emit('getImgurl', row.data.url)
                } else {
                    this.$message.error('上传失败，请重试');
                }
                this.circle = false;
            },
            uploadOnProgress(e, file, fileList) {//开始上传
                this.percentage = Math.floor(e.percent)
            },
            beforeAvatarUpload(row) {
                this.circle = true;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            }
        },
        mounted() {
            this.$nextTick(function () {
                // console.log("TEXT", this.text)
                // console.log("row", this.row)
            });
        },
        watch: {
            imgurl() {
                console.log(this.imgurl)
            }
        }
    }
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    /*
    进度条
     */
    .el-progress {
        background-color: #d4d4d4a6;
        /*position: absolute;*/
        /*width: 178px;*/
        /*height: 178px;*/
        /*top: 0px;*/
        /*left: 0px;*/
    }

    .avatar-uploader .el-progress {
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 25.5px;
        /*padding-left: 25.5px;*/

    }

    .avatar-uploader .el-progress .el-progress-circle {

    }
</style>
